import log from 'loglevel'
import { EigRootLogger } from './types'

export * from './RemoteLogger'
export * from './types'

export function getLog(level?: log.LogLevelDesc) {
  // log.setDefaultLevel(import.meta.env.PROD ? 'silent' : 'trace')
  if (level) {
    log.setDefaultLevel(level)
  }

  return log as EigRootLogger
}
